export default __webpack_public_path__ + "static/media/bracket_tbv_ketelisolatie.7a492ec3.png";